const PERSON_GROUP = {
	title: 'agents',
	type: 'title'
};
const OFFICE_GROUP = {
	title: 'offices',
	type: 'title'
};
const OC_PAGE_URL = '/iroda-kereso';

export const footerSearchComponent = {
	bindings: {
		type: '<'
	},
	templateUrl: 'office-and-advisor-search.html',
	controller: class footerSearchComponent {
		constructor($http, $timeout, $scope, $q, SearchService, $rootScope) {
			'ngInject';
			this.$http = $http;
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.resultList = [];
			this.$q = $q;
			this.searchService = SearchService;
			this.$rootScope = $rootScope;
		}

		$onInit() {
		}

		$onChange() {
		}

		querySearch(searchText) {
			if (searchText.length < 3) {
				return;
			}
			this.searchText = searchText;
			let params = {
				search: searchText
			};
			return this.$http({
				method: 'GET',
				url: '/public/agents-and-offices/search',
				params: params
			}).then((response) => {
				// Mock
				// response = mockResponse;

				this.locations = response.data.offices;
				this.agents = response.data.agents;
				this.resultList = this.transformResponse(this.locations, this.agents);
				return this.$q.resolve(this.resultList);
			}).catch((error) => {
				console.log(error);
				return this.$q.reject(this.resultList);
			});
		}

		transformResponse(locations, agents) {
			let retvalue = [];
			if (Array.isArray(agents) && agents.length) {
				retvalue.push(PERSON_GROUP);
				for (let i = 0; i < agents.length; i++) {
					agents[i].type = 'person';
					retvalue.push(agents[i]);
				}
			}
			if (Array.isArray(locations) && locations.length) {
				retvalue.push(OFFICE_GROUP);
				for (let i = 0; i < locations.length; i++) {
					locations[i].type = 'office';
					retvalue.push(locations[i]);
				}
			}
			return retvalue;
		}

		titleClick($event) {
			$event.preventDefault();
			$event.stopPropagation();
		}

		selectItem(item, searchText, fromSearchButton) {
			this.itemSelectedFromFooter(fromSearchButton, searchText, item);
		}

		setOfficesType(officeList) {
			for (let i = 0; i < officeList.length; i++) {
				officeList[i].type = 'office';
			}
		}

		itemSelectedFromFooter(fromSearchButton, searchText, item) {
			if (fromSearchButton) {
				// entert nyomott vagy keresésre kattintott
				window.localStorage.setItem('fromFooter', 'fromFooter');
				window.location.href = OC_PAGE_URL + '#/kereses=' + searchText + '/view=list';
				if (location.pathname.indexOf(OC_PAGE_URL) != -1) {
					location.reload();
				}
			} else {
				// elemet választott footerből, navigálni, popupban megjeleníteni
				window.localStorage.setItem('selectedItem', JSON.stringify(item));
				window.location.href = OC_PAGE_URL + '#/kereses=' + searchText + '/view=list';
				if (location.pathname.indexOf(OC_PAGE_URL) != -1) {
					location.reload();
				}
			}
		}

		search(searchText) {
			if (searchText) {
				this.selectItem(null, searchText, true);
			}
		}
	}
};
